import { render } from "./DocumentForm.vue?vue&type=template&id=136b09f8"
import script from "./DocumentForm.vue?vue&type=script&lang=js"
export * from "./DocumentForm.vue?vue&type=script&lang=js"

import "./DocumentForm.vue?vue&type=style&index=0&id=136b09f8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__